import React, { useEffect, useState } from "react";
import FrontVideo from "../../components/homevideo";
import HeaderTitle from "../../components/headerTitle";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import WhatWeOffer from "../../components/CommonSections/WhatWeOffer";
import Advantage from "../../components/CommonSections/Advantage";
import PageLoader from "../../components/home/pageload";
import ClientExperiences from "../../components/home/client-experiences";
import MetaTag from "../../components/CommonSections/MetaTag";
import SmartCityIntrodution from "../../assest/images/ishansecurescalable.png";
import { Link } from "react-router-dom";
import SubServiceSchema from "../../components/CommonSections/subServicesSchema";

export default function SecureAndScalableDigital() {
     const handleClick = () => {
          window.scrollTo(0, 0);
     }

     const [secureAndScalableData, setSecureAndScalableData] = useState(null);
     const [settingResponse, setSettingResponse] = useState(null);

     useEffect(() => {
          const requestData = {
               "service_tag": "ssdndi"
          };

          axios.post(`${API_BASE_URL}/api/securescalableservices/getSecureScalableServices`, requestData).then((response) => {

               setSecureAndScalableData(response);

               const generalSettingsData = response?.data?.data?.general_settings?.general_settings_data;

               const networkServicesSettingsData = generalSettingsData.find((item) => item.tag === "secure_and_scalable_digital") || null;
               const networkServicesSettingsResponse = JSON.parse(networkServicesSettingsData?.response || "{}");

               setSettingResponse(networkServicesSettingsResponse);
          }).catch((error) => {
               <PageLoader />
          })
     }, [])

     return (

          <>
               {secureAndScalableData == null ? (
                    <PageLoader />
               ) : (
                    <>
                    <SubServiceSchema title={secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                              [0].title} url='https://ishantechnologies.com/systems-integration/secure-and-scalable-digital' parentTitle='System Integration' parentUrl='https://ishantechnologies.com/systems-integration' />
                    <MetaTag data={secureAndScalableData} pageKey="secure_scalable_services"/>
                         <div className="page_heading responsive_heading">
                              <div className="container">
                                   <HeaderTitle headerTitledata={secureAndScalableData} pageKey="secure_scalable_services" />
                              </div>
                         </div>
                         <div className={`video hero-banner ${
                              !secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data[0].banner_title &&!secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data[0].banner_img_desc 
                                   ? 'no-content' 
                                   : ''
                              }`}
                              >
                              <FrontVideo homeData={secureAndScalableData} pageKey="secure_scalable_services" />
                              <div className="banner-content ">
                                        {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].banner_title && (
                                        <h2 className='home-heading'>
                                                  {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].banner_title}
                                        </h2>
                                        )}

                                        {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].banner_img_desc && (
                                        <p className="para">
                                                  {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].banner_img_desc}
                                        </p>
                                        )}

                                        {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].button_img_name && (
                                        <a href={secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].button_url}>
                                                  <button className="button hero-btn">
                                                  {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_banner_data
                                   [0].button_img_name}
                                                  </button>
                                        </a>
                                        )}
                                        </div>
                                        
                              </div>

                         <div className="empowering section-space spin-wrap">
                              <div className="spin-round-wrap">
                                   <div className="spin-round color-navy-blue">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>

                              <div className="container">
                                   <div className="empowering-inner">
                                        <div className="empowering-left">
                                             {<img src={SmartCityIntrodution} alt="Secure Scalable" height={60} width={60} loading="lazy"/>}
                                        </div>
                                        <div className="empowering-right" dangerouslySetInnerHTML={{ __html: secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_information_data[0]?.description }}>
                                        </div>
                                   </div>
                              </div>

                              <div className="spin-round-wrap">
                                   <div className="spin-round">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>
                         </div>

                         <div className="weoffer-bgdark">
                              <WhatWeOffer title={settingResponse?.what_we_offer} data={secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_offer_data} />
                         </div>

                         <Advantage title={settingResponse?.advantages} data={secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_advantages_data} />

                         <div className="client-experiences section-space">
                              <ClientExperiences homeData={secureAndScalableData} pageKey="secure_scalable_services" tag="ssdndi" />
                         </div>

                         <div className="supercharge supercharge-left">
                              <div className="container">
                                   <h2 className="supercharge-heading">{secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.title}</h2>
                                   <div className="supercharge-btns">

                                        {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.button_title_1 &&
                                             <Link to={secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.button_url_1}>
                                                  <button className="getintouch" onClick={handleClick}>{secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.button_title_1?.toUpperCase()}</button>
                                             </Link>
                                        }
                                        {secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.button_title_2 &&
                                             <Link to={secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.button_url_2} target="_blank">
                                                  <button className="getintouch" onClick={handleClick}>{secureAndScalableData?.data?.data?.secure_scalable_services?.secure_scalable_services_cta_banner_data[0]?.button_title_2?.toUpperCase()}</button>
                                             </Link>
                                        }
                                   </div>
                              </div>
                         </div>
                    </>
               )}
          </>
     );
}